"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Lovejoy Company brought absolute clarity to my complex tax situation. Their strategic planning saved me significant time and stress.",
  author: "Elena Vance",
  position: "Creative Director",
  company: "VANCE DESIGN",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_elena_vance.webp",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_elena_vance.webp-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_elena_vance.webp-wvc-sizes"
}, {
  quote: "The team at Lovejoy is incredibly proactive. They don't just file returns; they help us optimize our financial future year-round.",
  author: "Marcus Thorne",
  position: "CEO, Thorne Logistics",
  company: "THORNE LOGISTICS",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_marcus_thorne.webp",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_marcus_thorne.webp-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_marcus_thorne.webp-wvc-sizes"
}, {
  quote: "I finally feel in control of my business finances. Their ethical standards and attention to detail are truly unmatched.",
  author: "Sarah Jenkins",
  position: "Founder, Bloom Florals",
  company: "BLOOM FLORALS",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_sarah_jenkins.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_sarah_jenkins.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_sarah_jenkins.png-wvc-sizes"
}, {
  quote: "Professional, responsive, and deeply knowledgeable. Lovejoy Company is the partner every business owner needs for compliance.",
  author: "David Chen",
  position: "Managing Partner, Chen Law",
  company: "CHEN LAW",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_david_chen.webp",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_david_chen.webp-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_david_chen.webp-wvc-sizes"
}, {
  quote: "Their guidance through complex regulatory requirements gave me total peace of mind. I can focus on growth, not paperwork.",
  author: "Julia Rossi",
  position: "Founder, Rossi Tech",
  company: "ROSSI TECH",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_julia_rossi.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_julia_rossi.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_julia_rossi.png-wvc-sizes"
}];
const alumniLogos = [{
  name: "VANCE",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_vance.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_vance.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_vance.png-wvc-sizes"
}, {
  name: "THORNE",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_thorne.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_thorne.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_thorne.png-wvc-sizes"
}, {
  name: "BLOOM",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_bloom.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_bloom.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_bloom.png-wvc-sizes"
}, {
  name: "CHEN",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_chen.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_chen.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_chen.png-wvc-sizes"
}, {
  name: "ROSSI",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_rossi.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_rossi.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_rossi.png-wvc-sizes"
}, {
  name: "GLOBAL",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_global.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_global.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/logo_global.png-wvc-sizes"
}];
export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: carouselRef,
    isVisible: carouselVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: logosRef,
    isVisible: logosVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const goTo = (index: number) => {
    if (index === activeIndex) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveIndex((index + testimonials.length) % testimonials.length);
      setIsTransitioning(false);
    }, 250);
  };
  const handlePrev = () => goTo(activeIndex - 1);
  const handleNext = () => goTo(activeIndex + 1);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveIndex(prev => (prev + 1) % testimonials.length);
        setIsTransitioning(false);
      }, 250);
    }, 7000);
    return () => clearInterval(interval);
  }, [activeIndex]);
  const current = testimonials[activeIndex];
  return <section data-section-id="2392" id="client-peace-of-mind" className="bg-background text-foreground relative overflow-hidden py-24 md:py-[120px] px-6">
      <div className="absolute inset-0 bg-card/40 pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-x-0 top-0 h-px bg-border/60 pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-border/60 pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-mono text-xs tracking-widest text-muted-foreground mb-6">
            [05] / CLIENT TESTIMONIALS
          </span>
          <h2 className="font-default text-4xl md:text-5xl font-semibold tracking-tight">
            Client *Peace* of Mind
          </h2>
        </div>

        <div ref={carouselRef} className={`relative max-w-[900px] mx-auto transition-all duration-700 ease-out ${carouselVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Quote className="absolute -top-8 -left-4 md:-top-12 md:-left-12 text-accent/80 pointer-events-none" style={{
          width: "200px",
          height: "200px"
        }} strokeWidth={1} aria-hidden="true" />

          <div className="relative z-10 pt-16 md:pt-20">
            <div className={`transition-all duration-300 ease-out ${isTransitioning ? "opacity-0 translate-y-2" : "opacity-100 translate-y-0"}`}>
              <blockquote className="font-default text-2xl md:text-[2rem] md:leading-[1.3] font-normal italic tracking-tight text-foreground text-center max-w-[900px] mx-auto">
                {current.quote}
              </blockquote>

              <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-border/60 pt-6">
                <div className="flex items-center gap-4">
                  <SafeHydrate><Avatar className="size-16 rounded-lg border border-border">
                    <AvatarImage src={current.avatar} alt={current.author} />
                    <AvatarFallback className="rounded-lg bg-muted text-foreground font-mono text-sm">
                      {current.author.split(" ").map(n => n[0]).join("")}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="text-left">
                    <div className="font-default text-lg font-medium text-foreground">
                      {current.author}
                    </div>
                    <div className="text-sm text-muted-foreground">
                      {current.position}
                    </div>
                  </div>
                </div>
                <div className="font-mono text-xs tracking-widest text-muted-foreground">
                  {current.company}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 flex items-center justify-center gap-6">
            <Button variant="outline" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="rounded-lg border-border bg-transparent hover:bg-accent hover:text-accent-foreground">
              <ArrowLeft className="size-4" />
            </Button>

            <div className="flex items-center gap-2">
              {testimonials.map((t, i) => <Button key={t.author} data-index={i} onClick={() => goTo(i)} aria-label={`Go to testimonial ${i + 1}`} variant="ghost" size="sm" className={`size-2 p-0 rounded-lg transition-all duration-300 ${i === activeIndex ? "bg-accent w-6 hover:bg-accent" : "bg-muted-foreground/30 hover:bg-muted-foreground/60"}`} />)}
            </div>

            <Button variant="outline" size="icon" onClick={handleNext} aria-label="Next testimonial" className="rounded-lg border-border bg-transparent hover:bg-accent hover:text-accent-foreground">
              <ArrowRight className="size-4" />
            </Button>
          </div>
        </div>

        <div ref={logosRef} className={`mt-24 md:mt-32 transition-all duration-700 ease-out ${logosVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="text-center mb-10">
            <span className="font-mono text-xs tracking-widest text-muted-foreground">
              TRUSTED BY PROFESSIONALS AT
            </span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-8 gap-y-10 items-center">
            {alumniLogos.map((logo, i) => <div key={logo.name} data-index={i} className="flex items-center justify-center">
                <img src={logo.src} data-wvc-srcset={logo.srcset} data-wvc-sizes={logo.sizes} alt={logo.name} loading="lazy" decoding="async" className="h-8 w-auto object-contain opacity-50 hover:opacity-100 transition-opacity duration-300 grayscale" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}